/* eslint-disable import/no-named-default -- Conflict with composant name */
import { default as ReactDatePicker, registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import { ReactComponent as ChevronLeft } from 'assets/default/svg/ChevronLeft.svg'
import { ReactComponent as ChevronRight } from 'assets/default/svg/ChevronRight.svg'
import cn from 'classnames'
import './MonthPicker.scss'
import getYearsRange from 'utils/getYearsRange'

registerLocale('fr', fr)

interface Props {
  startDate: Date | null
  onChange: (date: Date | null) => void
  show?: boolean
  className?: string
  style?: React.CSSProperties
  type: string
}

const defaultProps = {
  show: true,
  className: undefined,
  style: {},
}

const MonthPicker = (props: Props): JSX.Element => {
  const { startDate, onChange, show, className, type, ...otherProps } = props

  const minDate = new Date('2014')
  const maxDate = new Date(new Date().getFullYear(), 12, 0)

  const years = getYearsRange(minDate, maxDate)

  const textTitle = () => (type === 'start' ? 'Date de Départ' : 'Date de fin ')

  const handleChange = (date: Date | null): void => {
    if (date === null) {
      return
    }

    const newDate =
      type === 'end'
        ? new Date(date.getFullYear(), date.getMonth() + 1, 0)
        : date
    onChange(newDate)
  }

  return (
    <div className="month-picker">
      <div
        className={cn('date-picker', { 'show-date-picker': show }, className)}
        {...otherProps}
      >
        <div className="month-picker-title">
          <p>{textTitle()}</p>
        </div>

        <ReactDatePicker
          showMonthYearPicker
          showFullMonthYearPicker
          dateFormat="MM/yyyy"
          locale="fr"
          selected={startDate}
          onChange={handleChange}
          startDate={startDate}
          minDate={minDate}
          maxDate={maxDate}
          inline
          renderCustomHeader={({
            date,
            changeYear,
            decreaseYear,
            increaseYear,
            prevYearButtonDisabled,
            nextYearButtonDisabled,
          }) => (
            <div className="react-datepicker__controls">
              <button
                className="react-datepicker__navigation react-datepicker__navigation--previous"
                type="button"
                onClick={decreaseYear}
                disabled={prevYearButtonDisabled}
              >
                <ChevronLeft />
              </button>
              <div className="react-datepicker__picker">
                <select
                  className="react-datepicker__picker--year"
                  value={date.getFullYear()}
                  onChange={({ target: { value } }) =>
                    changeYear(parseInt(value, 10))
                  }
                >
                  {years.map((option: string) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="button"
                className="react-datepicker__navigation react-datepicker__navigation--next"
                onClick={increaseYear}
                disabled={nextYearButtonDisabled}
              >
                <ChevronRight />
              </button>
            </div>
          )}
        />
      </div>
    </div>
  )
}

MonthPicker.defaultProps = defaultProps
export default MonthPicker
